import React from "react";

import { APP_TOOLTIP_ID } from "@/src/constants/tooltip";

import DataTableColumnHeader from "../../../dataTable/DataTableColumnHeader";
import { dateTimeColumn } from "../../../dataTable/dataTableColumns";
import IconByPlatform, {
  getPlatformFilterOptions,
  hasPlatformIcon,
} from "../../../utils/IconByPlatform";

import type { TFunction } from "i18next";

import type { UserSession } from "../../../../api/StatsAPI.types";
import type { DataTableColumnDef } from "../../../dataTable/dataTable.types";

interface UserSessionsColumnsOptions {
  t: TFunction;
}

export function userSessionsColumns({
  t,
}: UserSessionsColumnsOptions): DataTableColumnDef<UserSession>[] {
  return [
    {
      accessorKey: "session_uuid",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("sessionId")} />
      ),
      meta: { searchable: true, label: t("sessionId"), minWidth: 330 },
      cell: ({ row }) => row.original.session_uuid,
    },
    {
      accessorKey: "platform",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("platform")} />
      ),
      enableSorting: false,
      meta: {
        label: t("platform"),
        width: "30%",
        minWidth: 105,
        align: "center",
        filterOptions: getPlatformFilterOptions((platform) => t(platform)),
      },
      cell: ({ row }) => {
        if (!hasPlatformIcon(row.original.platform)) return null;

        const label = t(row.original.platform);
        return (
          <span
            className="inline-flex align-middle"
            data-tooltip-content={label}
            data-tooltip-id={APP_TOOLTIP_ID}
          >
            <IconByPlatform platform={row.original.platform} />
            <span className="sr-only">{label}</span>
          </span>
        );
      },
    },
    dateTimeColumn<UserSession>("created_at", t("createdAt"), {
      width: "15%",
      minWidth: 185,
    }),
  ];
}
